import classNames from "classnames"
import { cva } from "cva";
import { ChangeEvent, InputHTMLAttributes, useRef } from "react"
import type { VariantProps } from "cva";

export type BaseProps = {
    value?: string
    error?: boolean
    locked?: boolean
    size?: "sm" | "md" | "lg"
    isPreview?: boolean
}

type Props = BaseProps & Omit<InputHTMLAttributes<HTMLInputElement>, keyof BaseProps> & {
    type: "checkbox" | "radio" | "checkbox-radio"
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void | Function
} & VariantProps<typeof CheckboxStyles>

const CheckboxStyles = cva("border flex items-center justify-center cursor-pointer", {
    variants: {
        state: {
            default: [
                "-border--component-colors-check-radio-inactive-icon -text--component-colors-check-radio-inactive-icon",
                "disabled:-bg--component-colors-check-radio-disabled-icon-fill disabled:-border--component-colors-check-radio-disabled-icon",
                "hover:-text--component-colors-check-radio-hover-icon hover:-border--component-colors-check-radio-hover-icon  -rounded-checkbox",
            ],
            checked: [
                "-border--component-colors-check-radio-selected-icon -text--component-colors-check-radio-selected-icon",
                "disabled:-bg--component-colors-check-radio-disabled-icon-fill disabled:-border--component-colors-check-radio-disabled-icon",
                "hover:-text--component-colors-check-radio-hover-icon hover:-border--component-colors-check-radio-hover-icon",
            ],
            error: "-border--component-colors-check-radio-error-border -text--component-colors-check-radio-error-text placeholder:-text--component-colors-check-radio-error-placeholder",
        },
        size: {
            sm: "h-4 w-4",
            md: "h-5 w-5",
            lg: "h-6 w-6"
        }
    },

    defaultVariants: {
        state: "default",
        size: "md"
    }
})

const Checkbox = (props: Props) => {
    const { className, error, locked, isPreview, disabled, type, size = "md", checked, ...rest } = props

    const checkboxRef = useRef<HTMLInputElement>(null)
    const iconDimensions = (size === "sm" && "10") || (size === "md" && "12") || (size === "lg" && "14") || "12"
    const isChecked = checked || checkboxRef.current?.checked || false;
  
    const isDisabled = isPreview || disabled;

    
    return (

        (type === "radio" || type === "checkbox-radio") ?
            <div  className={classNames(CheckboxStyles({ state: (error && "error") || (isChecked && "checked") || "default", size }), "rounded-full p-1", className)}>
                {
                    isChecked &&
                    <div className="w-full h-full bg-current rounded-full"></div>
                }
                <input 
                    ref={checkboxRef}
                    {...rest}
                    checked={checked}
                    disabled={isDisabled}
                    className={"hidden"}
                    type={type === "checkbox-radio" ? "checkbox" : "radio"}
                />
            </div>
            :
            <div  className={classNames(CheckboxStyles({ state: (error && "error") || (isChecked && "checked") || "default", size }), className)}>
                {
                    isChecked &&
                    <svg className="absolute fill-current" xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height={iconDimensions} id="Layer_1" version="1.1" viewBox="0 0 24 24" width={iconDimensions}><path clipRule="evenodd" d="M21.652,3.211c-0.293-0.295-0.77-0.295-1.061,0L9.41,14.34  c-0.293,0.297-0.771,0.297-1.062,0L3.449,9.351C3.304,9.203,3.114,9.13,2.923,9.129C2.73,9.128,2.534,9.201,2.387,9.351  l-2.165,1.946C0.078,11.445,0,11.63,0,11.823c0,0.194,0.078,0.397,0.223,0.544l4.94,5.184c0.292,0.296,0.771,0.776,1.062,1.07  l2.124,2.141c0.292,0.293,0.769,0.293,1.062,0l14.366-14.34c0.293-0.294,0.293-0.777,0-1.071L21.652,3.211z" fillRule="evenodd" /></svg>
                }
                <input
                    ref={checkboxRef}
                    {...rest}
                    checked={checked}
                    disabled={isDisabled}
                    className={"hidden"}
                    type="checkbox"
                />
            </div>
    )
}

export default Checkbox;